export default "__VITE_ASSET__B$kwBgXh__"